import React, { Fragment, PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class RegionPanelSummary extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    formikProps: PropTypes.object.isRequired, // required for ResourceBlock selectors to function
    regionsList: PropTypes.array.isRequired,
    zonesList: PropTypes.array.isRequired,
    copyKey: PropTypes.string.isRequired,

    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "project_wizard.region_panel"
  };

  // -- RENDER -- //

  renderActive() {
    const {
      formikProps: { values },
      regionsList,
      zonesList,
      copyKey,
      copy
    } = this.props;

    const region = regionsList.find(item => item.value === values.region);
    const zone = zonesList.find(item => item.value === values.zone);

    return (
      <p>
        <strong>{copy(`${copyKey}.dropdown_label`)}: </strong>
        {region.text}
        {zone && (
          <Fragment>
            <br />
            <strong>{copy(`${copyKey}.zone_dropdown_label`)}: </strong>
            {zone.text}
          </Fragment>
        )}
      </p>
    );
  }

  renderInactive() {
    return null;
  }

  render() {
    const {
      formikProps: { values }
    } = this.props;

    if (values.region) {
      return this.renderActive();
    }

    return this.renderInactive();
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(RegionPanelSummary);
